import * as React from 'react';
import Icon from '../../Icon';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import Button from '../../Button';
import NewsTabs, { NewsTabsContainer } from '../NewsTabs';

export interface INewsModalSidebarProps {
  news: INewsListItem[];
  activeNewsItemId?: number | null;
  isLoading: boolean;
  totalPages: number;
  currentPage: number;
  onItemClick: (item: INewsListItem) => void;
  onFetchPageClick: (page: number) => void;
};

const NewsModalSidebar = ({
  news,
  activeNewsItemId,
  isLoading,
  totalPages,
  currentPage,
  onItemClick,
  onFetchPageClick
}: INewsModalSidebarProps) => {
  const hasNextPage = React.useMemo(() => currentPage < totalPages, [currentPage, totalPages]);
  const hasPreviousPage = React.useMemo(() => currentPage > 1, [currentPage, totalPages]);

  const handlePreviousPageClick = React.useCallback(
    () => onFetchPageClick(currentPage - 1),
    [currentPage, onFetchPageClick]
  );

  const handleNextPageClick = React.useCallback(
    () => onFetchPageClick(currentPage + 1),
    [currentPage, onFetchPageClick]
  );

  return (
    <NewsTabsContainer>
      <NewsTabs
        onItemClick={onItemClick}
        activeNewsItemId={activeNewsItemId}
        news={news}
      />
      <div className="flex justify-center mt-6">
        <Button
          className="mx-2"
          disabled={!hasPreviousPage}
          loading={isLoading}
          onClick={handlePreviousPageClick}
        >
          <Icon name="chevron-left" className="mr-1" />
          Vis 10 forrige
        </Button>

        <Button
          className="mx-2"
          disabled={!hasNextPage}
          loading={isLoading}
          onClick={handleNextPageClick}
        >
          Vis 10 næste
          <Icon name="chevron-right" className="ml-1" />
        </Button>
      </div>
    </NewsTabsContainer>
  );
}
export default NewsModalSidebar;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/Sidebar.tsx